import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from ".";




// =======================
// Generic GET request hook
// =======================
export function useGetQuery(key, url, config, isPublic = false) {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const api = apiClient;
      const response = await api.get(url, config);
      return response.data;
    },
  });
}

// =======================
// Generic POST mutation hook
// =======================
export function usePostMutation(url, isPublic = false, keys = []) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const api =  apiClient;
      const response = await api.post(url, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys });
    },
  });
}

// =======================
// POST FormData mutation
// =======================
export function usePostMutationForm(url, isPublic = false, keys = []) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData) => {
      const api = apiClient;

      const response = await api.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys });
    },
  });
}

// =======================
// Generic PUT mutation hook
// =======================
export function usePutMutation(url, isPublic = false) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const api = apiClient;
      const response = await api.put(url, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
}

// =======================
// Generic PATCH mutation hook
// =======================
export function usePatchMutation(url, isPublic = false) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const api = apiClient;
      const response = await api.patch(url, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
}

// =======================
// Generic DELETE mutation hook
// =======================
export function useDeleteMutation(url, keys = [], isPublic = false) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const api = apiClient;
      const response = await api.delete(`${url}/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys });
    },
  });
}
